module.exports = __webpack_public_path__ + "img/chevron-right.b1dd5e66.svg";